import * as React from 'react'

import { sortTagsAccordingToRelevance } from '../../../../common/utils/tags'
import { IItem } from '../../../../typings/searchResults'
import Highlighter from '../../../components/highlighter'
import TagList from '../../tagList'

interface IProps {
  item: IItem
  tags: string
  term: string
  expandable?: boolean
}

const Tags = ({ tags, term, item, expandable = true }: IProps) => {
  const keywords = term.split(' ')
  const sortedTagsString = sortTagsAccordingToRelevance(
    keywords,
    tags.split(','),
    item.tags
  ).join(', ')

  return (
    <TagList expandable={expandable}>
      <Highlighter bold keywords={keywords}>
        {sortedTagsString}
      </Highlighter>
    </TagList>
  )
}

export default Tags
